import React from "react";

const STAFF = [
  { name: "Ava", role: "Laser Tech", initials: "AV", color: "#3E4552" },
  { name: "Mia", role: "Dermal Therapist", initials: "MI", color: "#B5704F" },
  { name: "Zoe", role: "Cosmetic Nurse", initials: "ZO", color: "#A38059" },
];

// [column index, startHour(0=9am), durationHours, client, service, tone]
const APPTS = [
  [0, 0, 1, "Chloe Bennett", "Laser — Full legs", "confirmed"],
  [0, 1.5, 1, "Ruby Nguyen", "Laser — Underarms", "paid"],
  [0, 3, 1.5, "Hana Sato", "Laser — Brazilian", "confirmed"],
  [0, 5, 1, "Priya Shah", "Consult — Laser", "new"],
  [1, 0.5, 1.5, "Emma Walker", "Hydrafacial", "paid"],
  [1, 2.5, 1, "Grace Lee", "Dermaplaning", "confirmed"],
  [1, 4, 2, "Olivia Roy", "Skin Needling", "checked"],
  [2, 0, 1, "Sienna Ford", "Anti-wrinkle", "paid"],
  [2, 1.5, 1, "Layla Khan", "Lip filler", "confirmed"],
  [2, 3, 1, "Isla Moore", "Consult — Injectables", "new"],
  [2, 4.5, 1.5, "Mila Costa", "Cheek filler", "confirmed"],
];

const TONES = {
  confirmed: { bg: "#E8EBEE", bar: "#3E4552", text: "#2F3032" },
  paid: { bg: "#E9EFEA", bar: "#3D5A45", text: "#2F3032" },
  checked: { bg: "#E6EDF0", bar: "#7A8B96", text: "#2F3032" },
  new: { bg: "#F6EBE5", bar: "#B5704F", text: "#2F3032" },
};

const HOURS = ["9", "10", "11", "12", "1", "2", "3"];
const ROW_H = 46; // px per hour

export const CalendarPreview = () => (
  <div className="rounded-2xl border border-border bg-card shadow-2xl overflow-hidden select-none" data-testid="calendar-preview">
    {/* window chrome */}
    <div className="flex items-center gap-1.5 px-4 py-2.5 border-b border-border bg-muted/40">
      <span className="h-2.5 w-2.5 rounded-full bg-red-400" />
      <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
      <span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
      <span className="ml-3 text-xs text-muted-foreground font-medium">Today · Thursday 12 June — 3 therapists</span>
    </div>

    {/* staff header */}
    <div className="grid" style={{ gridTemplateColumns: "44px repeat(3, minmax(0, 1fr))" }}>
      <div className="border-b border-r border-border" />
      {STAFF.map((s) => (
        <div key={s.name} className="border-b border-r border-border px-3 py-2.5 flex items-center gap-2">
          <span className="h-7 w-7 rounded-full flex items-center justify-center text-[10px] font-bold text-white shrink-0" style={{ backgroundColor: s.color }}>{s.initials}</span>
          <div className="min-w-0">
            <div className="text-sm font-semibold leading-tight truncate">{s.name}</div>
            <div className="text-[10px] text-muted-foreground truncate">{s.role}</div>
          </div>
        </div>
      ))}
    </div>

    {/* grid body */}
    <div className="grid" style={{ gridTemplateColumns: "44px repeat(3, minmax(0, 1fr))" }}>
      {/* time rail */}
      <div className="relative" style={{ height: HOURS.length * ROW_H }}>
        {HOURS.map((h, i) => (
          <div key={h} className="absolute right-2 text-[10px] text-muted-foreground" style={{ top: i * ROW_H - 6 }}>{h}</div>
        ))}
      </div>
      {/* 3 columns */}
      {STAFF.map((_, col) => (
        <div key={col} className="relative border-l border-border" style={{ height: HOURS.length * ROW_H }}>
          {HOURS.map((_, i) => <div key={i} className="absolute inset-x-0 border-b border-border/60" style={{ top: (i + 1) * ROW_H }} />)}
          {APPTS.filter((a) => a[0] === col).map((a, idx) => {
            const [, start, dur, client, service, tone] = a;
            const t = TONES[tone];
            return (
              <div key={idx} className="absolute left-1 right-1 rounded-lg px-2 py-1 overflow-hidden shadow-sm"
                style={{ top: start * ROW_H + 2, height: dur * ROW_H - 4, backgroundColor: t.bg, borderLeft: `3px solid ${t.bar}` }}>
                <div className="text-[11px] font-semibold leading-tight truncate" style={{ color: t.text }}>{client}</div>
                <div className="text-[10px] leading-tight truncate" style={{ color: t.text, opacity: 0.8 }}>{service}</div>
              </div>
            );
          })}
        </div>
      ))}
    </div>

    {/* legend */}
    <div className="flex flex-wrap items-center gap-3 px-4 py-2.5 border-t border-border bg-muted/30 text-[10px] text-muted-foreground">
      {[["#3E4552", "Confirmed"], ["#3D5A45", "Paid"], ["#7A8B96", "Checked out"], ["#B5704F", "New client"]].map(([c, l]) => (
        <span key={l} className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: c }} />{l}</span>
      ))}
    </div>
  </div>
);
